var _excluded = ["children", "onClick", "style", "hover", "active", "focused", "type", "size", "className", "disabled", "disabledHelpText", "href", "htmlType", "id", "css"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { BaseButton, BaseAnchor, HelpLabel, ChildrenWrapper } from "./Button.styles";
export var Button = function Button(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      style = _ref.style,
      hover = _ref.hover,
      active = _ref.active,
      focused = _ref.focused,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'secondary' : _ref$type,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      className = _ref.className,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      disabledHelpText = _ref.disabledHelpText,
      href = _ref.href,
      _ref$htmlType = _ref.htmlType,
      htmlType = _ref$htmlType === void 0 ? 'button' : _ref$htmlType,
      id = _ref.id,
      css = _ref.css,
      other = _objectWithoutProperties(_ref, _excluded);

  var ComponentToUse = href ? BaseAnchor : BaseButton;
  var buttonStyle = type === 'default' ? 'secondary' : type;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(ComponentToUse, _extends({
    style: style,
    buttonStyle: buttonStyle,
    onClick: onClick,
    type: !href ? htmlType : null // don't assign type if anchor tag
    ,
    disabled: disabled,
    href: href,
    size: size,
    "data-cy": id,
    buttonCss: css
  }, other), /*#__PURE__*/React.createElement(ChildrenWrapper, null, children)), disabledHelpText && /*#__PURE__*/React.createElement(HelpLabel, {
    role: "alert"
  }, disabledHelpText));
};
Button.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Optional class name
   */
  className: PropTypes.string,
  id: PropTypes.string,
  children: PropTypes.node.isRequired,

  /**
   * Optional callback to run on the click event
   */
  onClick: PropTypes.func,
  style: PropTypes.object,
  hover: PropTypes.bool,
  active: PropTypes.bool,
  focused: PropTypes.bool,

  /**
   * Which type of button you want
   */
  type: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'default']),

  /**
   * The `type`-attribute of the button-tag
   */
  htmlType: PropTypes.oneOf(['button', 'submit', 'reset']),

  /**
   * One of the styleguide sizes
   */
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large']),

  /**
   * If provided, make the button into a link
   */
  href: PropTypes.string,

  /**
   * disable the button
   */
  disabled: PropTypes.bool,

  /**
   * Add a help text that will be presented as a complement to the disabled state
   */
  disabledHelpText: PropTypes.string,

  /**
   * Add css to override button styles
   */
  css: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
} : {};
export default Button;
//# sourceMappingURL=Button.js.map